export const PREVIOUS_ORDERS_MODAL = {
  title: 'previous-orders-modal-title',
  id: 'previous-orders-modal-id'
};
